import { render, staticRenderFns } from "./AccountingFirmWeekChargeControl.vue?vue&type=template&id=645e3b8e&scoped=true"
import script from "./AccountingFirmWeekChargeControl.vue?vue&type=script&lang=js"
export * from "./AccountingFirmWeekChargeControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e3b8e",
  null
  
)

export default component.exports